import React, { useState } from "react";
import { Button } from "antd";
import { PlusOutlined, FilterOutlined } from "@ant-design/icons";
import VendorFilters from "./VendorFilters";
import { useLocations } from "../../hooks/useLocation";

interface VendorHeaderProps {
  onAddVendor: () => void;
  onApplyFilters: (filters: Record<string, any>) => void;
  onClearFilters: () => void;
  canAddVendors: boolean;
  canSeeAllLocations: boolean; // New prop for location permission
}

const VendorHeader: React.FC<VendorHeaderProps> = ({
  onAddVendor,
  onApplyFilters,
  onClearFilters,
  canAddVendors,
  canSeeAllLocations,
}) => {
  const [showFilters, setShowFilters] = useState(false);
  const { data: locations } = useLocations();

  const locationOptions =
    locations?.map((location) => ({
      value: location.id,
      label: location.name,
    })) || [];

  const allFilterFields = [
    { key: "name", label: "Vendor Name", type: "text" as const },
    { key: "email", label: "Email", type: "text" as const },
    { key: "phone", label: "Phone Number", type: "text" as const },
    {
      key: "location_id",
      label: "Location",
      type: "select" as const,
      options: locationOptions,
      requiresPermission: true, // Only show if user has permission to see all locations
    },
  ];

  // Filter out location field if user doesn't have permission
  const filterFields = allFilterFields.filter(
    (field) => !field.requiresPermission || canSeeAllLocations
  );

  return (
    <div className="mb-6">
      <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center mb-4 space-y-4 lg:space-y-0">
        <div className="flex items-center space-x-2">
          <h1 className="text-lg lg:text-xl font-bold">Vendor Management</h1>
        </div>

        <div className="flex space-x-3">
          {canAddVendors && (
            <Button
              type="default"
              onClick={onAddVendor}
              icon={<PlusOutlined />}
              className="border border-primary text-primary"
            >
              Add New Vendor
            </Button>
          )}
          <Button
            icon={<FilterOutlined />}
            onClick={() => setShowFilters(!showFilters)}
          >
            Filters
          </Button>
        </div>
      </div>

      {showFilters && (
        <VendorFilters
          fields={filterFields}
          onApplyFilters={onApplyFilters}
          onClearFilters={onClearFilters}
          canSeeAllLocations={canSeeAllLocations}
        />
      )}
    </div>
  );
};

export default VendorHeader;
